<template>
    <div>
        <Head><title>Dashboard</title></Head>
        <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>

        <div v-show="showMpesaNotification" id="alert-additional-content-1"
             class="p-4 mb-4 text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800"
             role="alert">
            <div class="flex items-center">
                <svg class="flex-shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                     fill="currentColor" viewBox="0 0 20 20">
                    <path
                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                </svg>
                <span class="sr-only">Info</span>
                <h3 class="text-lg font-medium">Mpesa B2C password expiry reminder</h3>
            </div>
            <div class="mt-2 mb-4 text-sm">
                This is a polite reminder that your Mpesa B2C password will in expire in {{ mpesaRemainingDays }} days.
            </div>
            <div class="flex">
                <Link href="/settings/mpesa" type="button"
                      class="text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-xs px-3 py-1.5 me-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Update Password
                </Link>
            </div>
        </div>

        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <template #dateFilter>
                    <date-picker v-model="form.date" :range="true" :time-picker="false"
                                 :enable-time-picker="false" input-class-name="dp-custom-input" :multi-calendars="2"
                                 :preset-ranges="presetRanges" auto-apply>
                    </date-picker>
                </template>
            </search-filter>
        </div>
    </div>
    <div class="container items-center px-4 py-8 m-auto ">
        <div class="flex flex-wrap pb-3 mx-4 md:mx-24 lg:mx-0 mt-5">

            <summary-card
                title="Total Revenue" :card-link="cardOneLink"
                :totals=totalRevenue :percentage_change=percentageRevenueChange
                :change_direction=percentageRevenueIncrement #cardIcon>
                <icon name="dashboard" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                      fill="currentColor"></icon>
            </summary-card>
            <summary-card title="Organization Revenue" :totals=organizationRevenue :card-link="cardOneLink"
                          :percentage_change=percentageRevenueChange
                          :change_direction=percentageRevenueIncrement #cardIcon>
                <icon name="dashboard" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                      fill="currentColor"></icon>
            </summary-card>

            <summary-card title="Total Orders" :totals=totalOrders :percentage_change=percentageUsersChange
                          :card-link="cardOneLink"
                          :change_direction=percentageOrdersIncrement #cardIcon>
                <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                      fill="currentColor"></icon>
            </summary-card>

            <summary-card title="Revenue Per Order" :totals=revenuePerOrder :percentage_change=percentageProjectsChange
                          :card-link="cardOneLink"
                          :change_direction=percentageProjectsIncrement #cardIcon>
                <icon name="printer" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                      fill="currentColor"></icon>
            </summary-card>

            <!--            <summary-card title="Total Users" :totals=totalUsers :percentage_change=percentageUsersChange
                                      :change_direction=percentageUsersIncrement #cardIcon>
                            <icon name="users" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                                  fill="currentColor"></icon>
                        </summary-card>-->


        </div>

        <div class="flex gap-4 pb-3 mx-4 md:mx-24 lg:mx-0 mt-5">

            <BarChart :monthly-revenue="monthlyRevenue"/>
            <LineChart :monthly-orders="monthlyOrders"/>

        </div>
        <div class="flex gap-4 pb-3 mx-4 md:mx-24 lg:mx-0 mt-5">
            <PieChart :title="pieChatOne" :project-data="projectRevenue"/>
            <PieChart :title="pieChatTwo" :project-data="projectOrders"/>

        </div>

        <!-- latest transactions records-->

        <div class="overflow-x-auto relative">
            <h4 class="text-2xl font-semibold leading-normal mt-0 mb-5 text-gray-800">Latest Payments</h4>
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            #
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Reference
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Project
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Customer Name
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Customer Phone
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Amount
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                    <th scope="col" class="py-3 px-6">
                        <div class="flex items-center">
                            Date
                            <a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 ml-1" aria-hidden="true"
                                     fill="currentColor" viewBox="0 0 320 512">
                                    <path
                                        d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z"/>
                                </svg>
                            </a>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                    v-for="(payment, index) in latestTransactions.data" :key="index">
                    <th scope="row" class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">

                        {{ index + 1 }}
                    </th>
                    <th scope="row" class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        {{ payment.reference }}
                    </th>
                    <th scope="row">
                        <Link :href="`/projects/details/${payment.project_id}`">
                            {{ payment.project }}
                        </Link>
                    </th>
                    <td class="py-4 px-6">
                        <Link :href="`/users/details/${payment.user_id}`">
                            {{ payment.customer_name }}
                        </Link>
                    </td>
                    <td class="py-4 px-6">
                        <Link :href="`/users/${payment.user_id}/edit`">
                            {{ payment.customer_phone }}
                        </Link>
                    </td>
                    <td class="py-4 px-6">
                        {{ payment.amount }}
                    </td>
                    <td class="py-4 px-6">
                        {{ payment.date }}
                    </td>
                </tr>
                </tbody>
            </table>
            <button
                class="block w-full text-blue-800 text-sm font-semibold rounded-lg hover:bg-gray-100 focus:outline-none focus:shadow-outline focus:bg-gray-100 hover:shadow-xs p-3 my-4">
                <a href="/payments">
                    Show All Payments
                </a>
            </button>
        </div>

    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import SummaryCard from "@/Shared/SummaryCard";
import Icon from '@/Shared/Icon'
import BarChart from '@/Shared/BarChart.vue'
import PieChart from '@/Shared/PieChart.vue'
import LineChart from "@/Shared/LineChart.vue";

import SearchFilter from "@/Shared/SearchFilter.vue";
import mapValues from "lodash/mapValues";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import moment from 'moment'
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths,
    subYears
} from "date-fns";
import mpesa from "../Settings/Mpesa.vue";


export default {
    computed: {
        mpesa() {
            return mpesa
        }
    },
    components: {
        SummaryCard,
        Head,
        Icon,
        BarChart,
        PieChart,
        LineChart,
        SearchFilter,
        Link,

    },
    layout: Layout,
    props: {
        filters: Object,
        totalUsers: Number,
        revenuePerOrder: Number,
        percentageUsersChange: Number,
        percentageUsersIncrement: Boolean,

        totalOrders: Number,
        percentageOrdersChange: Number,
        percentageOrdersIncrement: Boolean,

        totalProjects: Number,
        percentageProjectsChange: Number,
        percentageProjectsIncrement: Boolean,

        totalRevenue: Number,
        organizationRevenue: Number,
        percentageRevenueChange: Number,
        percentageRevenueIncrement: Boolean,

        //charts data
        monthlyRevenue: Array,
        monthlyOrders: Array,
        projectRevenue: Object,
        projectOrders: Array,

        //latest transactions
        latestTransactions: Array,

        showMpesaNotification: Boolean,
        mpesaRemainingDays: Number
    },
    data() {
        return {
            form: {
                date: this.filters.date,
            },
            pieChatOne: "Projects Revenue",
            pieChatTwo: "Projects Orders",
            cardOneLink: "/payments",

            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        moment: function () {
            return moment();
        },

    },
}

</script>
